/**
 * The four roles, ranked as in the backend (apps/accounts/models.py). Each role can do
 * everything the roles below it can. This copy only decides what to *show*: the API
 * enforces the same ranks on every request, so it can hide a button but never grant one.
 */
export const ROLES = ["viewer", "editor", "admin", "super_admin"] as const;
export type Role = (typeof ROLES)[number];

const RANK: Record<Role, number> = { viewer: 10, editor: 20, admin: 30, super_admin: 40 };

export const ROLE_LABEL: Record<Role, string> = {
  viewer: "Viewer",
  editor: "Editor",
  admin: "Admin",
  super_admin: "Super Admin",
};

export const ROLE_SUMMARY: Record<Role, string> = {
  viewer: "Can read every item, its tabs and the activity on it.",
  editor: "Edits the three tabs, reviews, publishes, and writes newsletters.",
  admin: "Manages source websites, subscribers, sends newsletters and watches the agents.",
  super_admin: "Everything, plus users, Website Configuration and imports.",
};

export function hasRole(role: Role | undefined | null, minimum: Role): boolean {
  return !!role && RANK[role] >= RANK[minimum];
}
